import { Stack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { BalanceEntity, CustomerEntity } from '@genial/services';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { SelectedCustomer } from '../../../../store/customer/types';
import { SectionContainer } from '../SectionContainer';
import { SectionItem } from '../SectionItem';

import { createSectionCustomerItems } from './constants';

export interface CustomerSectionProps extends CustomerEntity, BalanceEntity {
  fullCustomerItem?: SelectedCustomer;
}

export const CustomerSection: React.FC<CustomerSectionProps> = (props) => {
  const device = useBreakpointValue({ base: 'mobile', sm: 'tablet', lg: 'desktop' } as const);
  const sectionItems = createSectionCustomerItems({ ...props, device });

  const renderSections = () => {
    const sections = sectionItems?.map((item, index: number, array: typeof sectionItems) => {
      const isLast = index === array.length - 1;
      return <SectionItem key={item.testID} {...item} isLast={isLast} />;
    });
    return sections;
  };

  return (
    <SectionContainer title="Detalhes do cliente">
      <Stack
        direction={{ base: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ base: 'flex-start', sm: 'center' }}
        space={{ base: Spacing['inline.nano'], sm: 0 }}>
        {renderSections()}
      </Stack>
    </SectionContainer>
  );
};
